<script lang='ts'>
  export let val: any;
  export let changeCB: any;
  export let domId:string;
  export let loading=false;

  function enableLogo(event: any) {
    if (event && event.srcElement) {
      val = !val;
      changeCB();
      event.stopPropagation();
    }
  }
</script>
<label class='fizz-toggle' on:click|preventDefault={enableLogo}>
  <input type="checkbox" id={`enable_${domId}`} class="fizz-toggle"
    bind:checked={val} on:click|preventDefault disabled={loading} />
  <span class="fizz-toggle-switch" />
</label>
